<template>
  <div>
    <AppNavigationTop :navigationInfo="AppNavigationTopInfo"/>
    <v-container fluid grid-list-xl>
      <v-layout wrap row align-center justify-centre fill-height class="mt-2 ml-1">
        <v-flex xs12 sm12 md11 lg9 xl6 offset-md0 offset-lg2 offset-xl3>
          <div :class="ui.textTitle">
            Facility Contractor View
          </div>
        </v-flex>
        <v-flex xs12 sm6 md6 lg3 xl2 offset-md0 offset-lg2 offset-xl3>
          <FacilityCardDetail/>
        </v-flex>
        <v-flex xs12 sm6 md6 lg3 xl2>
          <HazardCard/>
        </v-flex>
        <v-flex xs12 sm6 md6 lg3 xl2 offset-md0 offset-lg0>
          <OpsCard/>
        </v-flex>
      </v-layout>
      <v-layout row mb-4>
      </v-layout>
      <v-layout row mb-4>
      </v-layout>
    </v-container>
    <AppNavigationBottom/>
</div>
</template>

<script>
import AppNavigationBottom from "@/frame/navigation/components/AppNavigationBottom";
import AppNavigationTop from "@/frame/navigation/components/AppNavigationTop";
import HazardCard from "@/frame/card/components/HazardCard";
import OpsCard from "@/frame/card/components/OpsCard";
import FacilityCardDetail from "@/frame/card/components/FacilityCardDetail";
import currentPage from "@/frame/pages/mixins/currentPage.js";
import storeFunctions from "@/data/functions/mixins/storeFunctions.js";
import { mapGetters } from "vuex";
import apptheme from "@/frame/theme/mixins/apptheme.js";

export default {
  components: {
    AppNavigationBottom,
    AppNavigationTop,
    FacilityCardDetail,
    HazardCard,
    OpsCard
  },
  // eslint-disable-next-line
  mixins: [
    currentPage,
    apptheme,
    storeFunctions
  ],
  created() {
    this.$store.dispatch("changeCompanyDID", this.getUser.pref.select.cdid);
    this.resetRegisters();
  },
  data() {
    return {
      currentPagePath: "/facilitydashviewcontractor"
    };
  },
  computed: {
    // eslint-disable-next-line
    ...mapGetters(["getUser", "getCompany", "getCurrentPage", "getPreviousPage"]),
    AppNavigationTopInfo() {
      let obj = {
        title: "Company",
        titleColour: "wplblue0--text",
        btns: [
          {
            title: "main",
            icon: "apps",
            link: "/appdash"
          },
          {
            title: "sign out",
            icon: "person_outline",
            link: "/signout"
          }
        ]
      };
      if (this.getUser.pref.select.cauth !== null) {
        obj.title = this.getUser.pref.select.cname;
      }
      return obj;
    }
  },
  beforeMount() {
    this.$store.dispatch("changePreviousPage", this.getCurrentPage);
    this.$store.dispatch("changeCurrentPage", this.currentPagePath);
    if (this.getCompany !== null) {
      if (this.getUser.pref.select.cdid !== this.getCompany.basic.did) {
        this.$store.dispatch("changeCompany", null);
      }
    }
    this.$store.dispatch("changeCompanyDID", this.getUser.pref.select.cdid);
    // DEFINE type of Document Log for future updates Read/Undear updates
    this.$store.dispatch("changeDocumentLogTag", "C1");
    // STRAT USER STORE for COMPANY ACTIONS REGISTER
    let basic = {
      did: this.getUser.pref.select.cdid,
      title: this.getUser.pref.select.cname,
      idg: this.getUser.pref.select.cdid,
      id: this.getUser.pref.select.cid,
      tag: "C1"
    };
    this.$store.dispatch("changeDetailBasic", basic);
  }
};
</script>
